import { NgModule } from '@angular/core';
import { AsmAuthService, AsmRootModule } from '@spartacus/asm/root';
import { CmsConfig, OAuthLibWrapperService, provideConfig } from '@spartacus/core';
import { VscaOAuthLibWrapperService } from '../../../../core/auth/user-auth/service/vsca-oauth-lib-wrapper.service';
import { CustomAsmAuthService } from './asm-auth.service';


@NgModule({
  declarations: [],
  imports: [AsmRootModule],
  providers: [
    {
      provide: OAuthLibWrapperService,
      useExisting: VscaOAuthLibWrapperService,
    },
     {
      provide: AsmAuthService,
      useExisting: CustomAsmAuthService,
    },
     provideConfig({
      featureModules: {
        asm: {
          module: () => import('./asm-components.module').then((m) => m.CustomAsmModule),
          cmsComponents: [
            'AsmUserLoginComponent'
          ]
        },
      },
    } as CmsConfig),
  ],
})
export class AsmFeatureModule {}
